import { FC, useContext } from 'react';

import { Tabs } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { useMinLoadingTime } from '../useMinLoadingTime';
import s from './AllAdvertisement.module.scss';
import {
  AdvertisementItem,
  // AdvertisementItem,
  AllAdvertisementSkeleton,
  PartnerItem,
  // PartnerItem,
} from './components';
import { EAdvertisementCategories, IAllAdvertisements } from './interfaces';

export const AllAdvertisement: FC<IAllAdvertisements> = ({
  allAds,
  partners,
  loading,
  advertisementCategories,
  setAdvertisementCategories,
  setAdvertisementViewState,
  searchStr,
}) => {
  const { t } = useContext(LocalizationContext);
  const showSkeletons = useMinLoadingTime(loading, 350);
  const ADVERTISEMENT_CATEGORIES_OPTIONS = [
    {
      title: t('all'),
      value: EAdvertisementCategories.ALL,
    },
    {
      title: t('goods'),
      value: EAdvertisementCategories.GOODS,
    },
    {
      title: t('services'),
      value: EAdvertisementCategories.SERVICES,
    },
  ];

  return (
    <div className={s.container}>
      <div className={s.top}>
        <Tabs
          options={ADVERTISEMENT_CATEGORIES_OPTIONS}
          onChange={(value) => setAdvertisementCategories(value)}
          value={advertisementCategories}
          className={s.tabs}
        />
      </div>
      <div className={s.cards}>
        {!showSkeletons && (
          <>
            {(!searchStr || searchStr.length < 4) &&
              partners?.map((item) => (
                <PartnerItem key={item.id} data={item} />
              ))}

            {allAds?.map((item) => (
              <AdvertisementItem
                key={item.id}
                data={item}
                setAdvertisementViewState={setAdvertisementViewState}
              />
            ))}
          </>
        )}

        {showSkeletons &&
          Array.from({ length: 12 }).map((_, index) => (
            <AllAdvertisementSkeleton key={index} />
          ))}
      </div>
    </div>
  );
};
